<template>
  <div>
    <div class="contentMenu" :class="{marginCenter:centerBtn}">
      <p v-if="centerBtn" class="back" @click="back">返回上一页</p>
      <div style="height:5px"></div>
      <h4 class="marginl10">创建案件并启动救援</h4>
      <div>
      <div v-if=" apptodo>0 && $route.name == 'appcase'" class="app-aj">
        <div class="appdc padding-20">待处理案件:({{apptodo}}) <span class="app-ba">此处案件为大救星APP用户报案，请尽快处理</span></div>
        <div v-for="(acase,idx) in apptodolst" :key="idx">
          <div class="clan">
            <el-checkbox name="appcaselst" @change="changeAppcase(idx)" v-model="apptodolst[idx].checked"></el-checkbox>
            <span>{{time(acase.obj.reportTs)}}</span>
            <span>由用户<a class="mingc">{{acase.obj.reportUser}}</a>报案</span>
            <span>【{{acase.incidentTypeStr}}】</span>
            <span>出险人:{{acase.victimList!=null&&acase.victimList.length>0?acase.victimList[0].obj.victimName:""}}{{acase.victimList!=null&&acase.victimList.length>0&&judgeNull(acase.victimList[0].insuranceCompany)?"":",在保"}}</span>
            <span>出险地:{{acase.victimList!=null&&acase.victimList.length>0&&acase.generalLocation!=null?setTxt(acase.generalLocation.addr):""}}</span>
          </div>
        </div>
      </div>
      </div>
      <!--B、出险信息-->
      <h5 class="marginl10">A、出险信息
         <span class="padding-20 span_node">案件编号：{{reportcase.caseNo}}</span>
        <span v-if="this.$route.name == 'newstar'" class="padding-20 lisave span_node" @click="centerDialogVisible=true">创建关联案件</span>
      </h5>
      <div class="marginl10">
        <table class="padding-bj pad-0-10" cellpadding="5">
          <!-- <tr>
            <td><span>发起人：</span><span>{{llrName.name}}</span></td>
            <td><span>发起人手机号：</span><span>13256536956</span></td>
            <td><span>大救星ID：</span><span>{{reportcase.djxId}}</span></td>
          </tr> -->
          <tr> 
            <td>
                报案时间:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.reportTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td >
              <span class="">保险公司座席工号:</span>
              <el-input  v-model="reportcase.insuranceSeat" class="marginl10"></el-input>
            </td>
              <td>
            <!-- <td>
              <span class="">被保险人:</span>
              <el-input placeholder="请输入被保险人" v-model="reportcase.victimName" class="marginl10"></el-input>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td>
              <span class="">性别:</span>
              <el-select v-model="reportcase.gender" @change="genderselect" placeholder="请选择" class="marginl10 w100">
                <el-option v-for="item in genderlst" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              &nbsp;
            </td> -->
            <td></td>
          </tr>
          <!-- <tr>
            手机号：
            <el-input placeholder="请输入手机号" v-model="nationalMobile" class="marginl10"></el-input> 
            <span class="must">*</span>
            <el-button type="primary" size="small" @click="queryPhone()" style="margin-right:20px;">查询</el-button>
            <el-button type="primary" size="small" @click="dialogFormVisible3=true">创建大救星账号</el-button>
          </tr>  -->
          <tr>
              <span class="">被保险人:</span>
              <el-input placeholder="请输入被保险人" v-model="reportcase.victimName" class="marginl10"  @keydown.native="keydown($event)"></el-input>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td>
              <span class="">所属保险公司:</span>
              <el-select v-model="reportcase.insuranceCompanyId" @change='suoshuFun' class="marginl10 w213" placeholder="请选择保险公司"
                filterable>
                <el-option v-if='item.insti.name' v-for="item in companies" :key="item.id" :label="item.insti.name"
                  :value="item.insti.id"></el-option>
              </el-select>
              <span class="must">*</span>
            </td>
            <!-- <td>
              <span class="">保单号码:</span>
              <el-input placeholder="请输入保单号码" v-model="reportcase.insurancePolicyNo" class="marginl10"></el-input>
                   &nbsp;
              <span class="must">*</span>
              &nbsp;
            </td> -->
            <td></td>
          </tr>
          <tr>
             <td v-if="companies1.length != 0 && reportcase.insuranceCompanyId != ''">
              <span class="">保险公司子公司:</span>
              <el-select v-model="reportcase.subRegulatorId"  class="marginl10 w213"  @change='suoshuFunz' placeholder="请选择保险公司"
                filterable>
                <el-option  v-for="item in companies1" :key="item.id" :label="item.name"
                  :value="item.id" @click.native="contractEndTimechange(item)"></el-option>
              </el-select>
              <span class="must">*</span>
            </td>
            <td>
              <span class="">服务类型:</span>
              <el-select v-model="reportcase.accidentType" @change="accidentTypechange()" placeholder="请选择">
                <el-option v-for="item in accidentTypes" :key="item.serviceType" :label="item.serviceType" :value="item.serviceType"></el-option>
              </el-select>
              &nbsp;
              <span class="must">*</span>
              &nbsp;
              <div style="margin-top:10px;color: red;" v-if="reportcase.accidentType == '疏通马桶服务'">1.平安“莞逸家”,星灿保险仅限“马桶/蹲便”疏通，其他管道概不负责
                <br>2.派单时，告知师傅需拍照</div>
            </td>
            </tr>
          <tr>
          </tr>
           <tr >                     
          </tr>
           <tr>
              <td>
              <span class="">保单号码:</span>
              <el-input placeholder="请输入保单号码" v-model="reportcase.insurancePolicyNo" class="marginl10" @blur="insurancePolicyNoblur"  @keydown.native="keydown($event)"></el-input>
                   &nbsp;
              <!-- <span class="must">*</span> -->
              <span v-if="showProblemPolicyTip" style="color: red; margin-left: 8px;">问题履约保单</span>
              &nbsp;
              <div style="margin-top:10px;color: red;">开锁/马桶：向平安客服询问2个问题1.保单在不在保险期间；2.是否有权益；</div>
            </td>
            <td>
              <span class="">产品名称:</span>
              <el-input   v-model="reportcase.caseProductName" class="marginl10"></el-input>
              &nbsp;
              <div style="margin-top:10px;color: red;">平安臻享逸家高端家财险(全家版)产品无需核实权益和使用次数</div>
              <!-- <span class="must">*</span> -->
            </td>
            <!-- <td >
              <span class="">保险公司座席工号:</span>
              <el-input  v-model="reportcase.insuranceSeat" class="marginl10"></el-input>
            </td> -->
          </tr>
          <tr>
            <td colspan="1">
              <span class="">小保单号:</span>
              <el-input  v-model="reportcase.miniPolicy" class="marginl10" @blur="insurancePolicyNoblur"  @keydown.native="keydown($event)"></el-input>             
            </td>
               <td colspan="1">
              <span class="">被保人证件:</span>
              <el-input placeholder="请输入被保人证件" v-model="reportcase.idNo" class="marginl10" @change="idnochange"  @keydown.native="keydown($event)"></el-input>
              &nbsp;
              <span class="must">*</span>
              &nbsp;
            </td>
          </tr>
          <tr>
             <td>
              <span class="">性别:</span>
              <el-select v-model="reportcase.gender" @change="genderselect" placeholder="请选择" class="marginl10 w100">
                <el-option v-for="item in genderlst" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              &nbsp;
            </td>
              <td colspan="2">
                <span style="float: left;margin-top: 37px;">
                      <span class="">出险地:</span>
                        <el-select v-model="reportcase.siteabroadExpr" @change="caseabroad(1)" class="w75" placeholder="境内">
                          <el-option v-for="item in abroad" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                        <span class="must" v-if="reportcase.siteabroadExpr=='境外'">*</span>
                        <el-select v-model="reportcase.nation" v-if="reportcase.siteabroadExpr=='境外'" @change="loadcounties('',false,1)"
                          class="w120" placeholder="请选择国家" filterable>
                          <el-option v-for="item in countries" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <span class="must">*</span>
                        <el-select v-model="reportcase.city" class="w130" placeholder="请选择地区" filterable>
                          <el-option v-for="item in counties" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
                        </el-select>
                        <span class="must">*</span>
                </span>              
              <changeLanguage ref=changeLanguage :changeText='reportcase.addr' class="w303" v-model='reportcase.addr'></changeLanguage>
              <span class="must">*</span>
              <!-- <span class="blue" @click="getGps(1)">获取当前GPS</span> -->
              <div class="w303">
               <el-input style="width:200px" v-model="Longitudeandlatitude"  @blur="Longitudeandlatitudeblur"></el-input>
              <span style="min-width: 240px;display: inline-block;">经度：{{reportcase.latitude}}；纬度：{{reportcase.longitude}}</span>
              <div>
                 <a href="https://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank">获取当前GPS<span class="must">*</span> </a>
              </div>
              </div>             
            </td>
          </tr>                
        </table>                
      </div>
 <!--A、案件基本信息-->
      <h5 class="marginl10 margint-10">
        B、案件基本信息
        <span v-if="memberLevelLabel" class="padding-20 span_node member-level-header">
          <span
            class="member-level-badge"
            :class="'member-level-badge--' + memberLevelClass"
          >{{ memberLevelLabel }}</span>
        </span>
         <!-- <el-button style="float: right;margin-right: 60px;" type="primary" @click="draft">草稿</el-button> -->
          <el-button type="primary" class="w200" v-if="this.$route.query.creat != 1" style="width: 150px;position: fixed;top:170px;right: 175px;" @click="alertyb=false;submitcase(1,false)" >保存救援服务</el-button>
      </h5>
      <div class="marginl10">
        <div>
          <table class="padding-bj pad-0-10" cellpadding="5">
            <tr>
              <!-- <td>
                报案时间:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.reportTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td> -->
              <!-- <td>
                报案人:
                <el-input placeholder="请输入报案者姓名" v-model="reportcase.reportUser" class="marginl10"></el-input>
                &nbsp;
                <span class="must">*</span>
              </td> -->
            <td>
                报案人:
                <el-input placeholder="请输入报案者姓名" v-model="reportcase.reportUser" class="marginl10"  @keydown.native="keydown($event)"></el-input>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td>
                报案电话:
                <el-input placeholder="请输入报案者联系电话" v-model="reportcase.reporterContact" class="marginl10"  @keydown.native="keydown($event)"></el-input>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td></td>
            </tr>           
            <tr>
              <td>
                案件信息来源:
                <el-select v-model="reportcase.caseSrc" placeholder="请选择" class="marginl10" :disabled="ifyjjy">
                  <el-option v-for="item in casesrclst" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span class="must">*</span>
              </td>
              <td>
                <span class="back-wc" style="float: left;margin-top: 47px;"> 来源说明:</span>              
                <!-- <el-input placeholder="请输入来源说明" v-model="reportcase.caseSrcDesc" class="marginl10"></el-input> -->
                <changeLanguage :changeText='reportcase.caseSrcDesc' style='display: inline-block;' class="marginl10"
                  v-model='reportcase.caseSrcDesc'></changeLanguage>
                &nbsp;
                <!-- <span class="must">*</span> -->
              </td>
            </tr>
            <!-- <tr>
              <td>
                渠道：
                <el-select v-model="reportcase.channel" placeholder="旅责险" class="marginl10" style="width:20%">
                  <el-option v-for="item in chanelSelect" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span class="must">*</span>
                <el-input style="width:30%" placeholder="" class="marginl10"></el-input> -->
              <!-- </td>
            </tr> -->
            <tr v-if="reportcase.channel == '旅责险'">
              <td>
                旅行社名称：
                <el-select v-model="reportcase.travelId" placeholder="请选择旅行社" class="marginl10" filterable>
                  <el-option v-for="(item,index) in restaurants" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <span class="must">*</span>
                <!-- <el-button type="primary" size="small" @click="queryTravelAgency()">查询旅行社</el-button> -->
              </td>
            </tr>
            <tr v-if="reportcase.channel == '其他'">
              <td>
                渠道名称：
                <el-input v-model="reportcase.channel1" placeholder="请输入渠道"></el-input>
                <span class="must">*</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!--G、案件处理信息-->
      <div class="g serviceBrief">
        <h5 class="marginl10">C、案件处理信息 </h5>
        <!-- <ul>
          <li>
            <h4>2019/04/05 <small>服务简报</small></h4>
            <p>今天提供的服务内容是协助客户就医问诊，家属成员包括客户的女儿和妻子及旅行社的需求，服务总时长为5个小时左右</p>
          </li>
        </ul> -->
          <table class="padding-bj pad-0-10" cellpadding="5">
            <tr>
              <td colspan="2" style="padding-top: 0px;">
                上门服务时间:
                <el-date-picker style="width: 13%;" type="datetime" placeholder="上门服务时间" v-model="reportcase.incidentTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
            </tr>
            <td v-if="reportcase.coupon_discount_id != '' && reportcase.coupon_discount_id != null && reportcase.coupon_discount_id != undefined">
              <span class="back-wc" >第三方订单号:</span>
              <el-input :disabled="true" placeholder="请输入第三方订单号" v-model="reportcase.coupon_discount_id" class="marginl10"></el-input>
            </td>
            <tr>
              <td>
                卡券号:
                <el-input :disabled="true" placeholder="请输入卡券号" v-model="reportcase.idProfitRedeem" class="marginl10"></el-input>
              </td>
              <td>
                卡券名称:
                <el-input :disabled="true" placeholder="请输入卡券名称" v-model="reportcase.couponName" class="marginl10"></el-input>
              </td>
            </tr>
          </table>
           <div class="p1026" style="padding: 10px 0px;">
        <span class="back-wc" style="float: left;margin-top: 47px;padding-left: 19px;">服务经过:</span>
        <changeLanguage style="margin-top: 10px;width:40%"  class="w88100" :changeText='reportcase.incidentDesc' v-model='reportcase.incidentDesc'></changeLanguage>
      <div style="display: inline-block;color:#ccc" v-if="reportcase.accidentType == '疏通马桶服务'">
        <div >服务经过输入内容例如：马桶疏通服务</div>
        <div>*客户马桶因有异物卡住</div>
        <div>*客户家中马桶为蹲便</div>
        </div>
        <div style="display: inline-block;color:#ccc" v-if="reportcase.accidentType == '开锁服务'">
        <div >服务经过输入内容例如：紧急开锁</div>
        <div>*客户忘带钥匙需要开锁</div>
        <div>*客户需要预约开锁</div>
        <div>*客户锁型为王力/保德安锁，请确认是否可以开具</div>
        </div>
      </div>
      </div>
      <div style="text-align: center;margin-top:20px;padding-bottom:20px;">
        <el-button type="primary" class="w200" @click="submitcase(2,true)" v-if="(formRoute == 'caseDetails' || formRoute == 'monitoring' || formRoute == 'underway') && this.$route.name != 'Familywealth'">确认补充信息</el-button>
        <el-button type="primary" class="w200" @click="alertyb=false;submitcase(2,false)" >创立案件</el-button>
        <el-button type="success" class="w200" @click="extractServiceInfo" v-if="this.$route.query.creat == 1" style="margin-left: 10px;">一键提取上门信息</el-button>
      </div>
    </div>
    <!-- 添加 -->
    <el-dialog title="添加协调人" :visible.sync="showcooperaterDialogVisible" center top="1vh" width="1000px" @close="toggleSelection()">
      <el-table empty-text="暂无数据" :data="cooperaterData" class="mgt15" border @selection-change="handleSelectionChange"
        ref="multipleTable">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="30"></el-table-column>
        <el-table-column prop="mobileNo" label="手机号" min-width="30"></el-table-column>
        <el-table-column prop="nationalId" label="证件号码" min-width="30"></el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 10px;">
        <el-button type="primary" @click='showcooperaterDialogVisible=false;cooperaterDataList=cooperaterDataList1'>确定</el-button>
        <el-button @click='toggleSelection();showcooperaterDialogVisible=false;'>取消</el-button>
      </div>
    </el-dialog>
    <!-- 添加新注册的协调人 -->
    <el-dialog title="添加新注册的协调人" :visible.sync="addContacterDialogVisible" center top="1vh" width="600px">
      <el-form :model="addcontacterform" ref='ruleForm'>
        <el-form-item label="姓名:" :label-width="formLabelWidth" prop="name">
          <el-input v-model="addcontacterform.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" :label-width="formLabelWidth" prop="mobileNo">
          <el-input v-model="addcontacterform.mobileNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="证件号码:" :label-width="formLabelWidth" prop="nationalId">
          <el-input v-model="addcontacterform.nationalId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录名:" :label-width="formLabelWidth" prop="passport">
          <el-input v-model="addcontacterform.passport" placeholder="请输入登录名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录密码:" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="addcontacterform.password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubUser">注册并添加到协调名单</el-button>
      </div>
    </el-dialog>
    <!-- 旅责险星使服务范围提示 -->
    <el-dialog title="旅责险星使服务范围提示" :visible.sync="xingshiServiceDialogVisible" center top="1vh" width="1000px">
      <h5>服务内容</h5>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">现在慰问、关怀</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">案件情况核实</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">案件处理协助</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">治疗情况确认</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">向导翻译服务</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">协助联系使领馆服务</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">证件补办协助服务</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple" style="color:#fe893f">其他服务要求请拨打全国调处确认后发出</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple" style="color:#fe893f">无法进行案件查勘工作</div>
        </el-col>
      </el-row>
      <h5>服务地区</h5>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple" style="text-align:left">泰国、印度尼西亚、越南、马来西亚、日本、美国、俄罗斯、柬埔寨、新加坡、菲律宾、澳大利亚、加拿大、法国、意大利、德国、瑞士、新西兰、英国、西班牙等及中国香港、澳门地区（现有星使的国家109个）</div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="xingshiServiceDialogVisible = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- GPS -->
    <div class="gpsBox" :style="{visibility:gpsBox?'initial':'hidden'}">
      <gpsBox ref='gpsBox' @getGpshid='getGpshid' @getGpshid1='getGpshid1'></gpsBox>
    </div>
    <!-- 提示有保 -->
    <!-- <el-dialog title="提示！" center :visible.sync="dialogFormVisible1" width="500px">
      <center>该出险人没有星使服务保险保障，费用将需要外部解决，是否创建星使派单？</center>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="alertyb=false;dialogFormVisible1 = false">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="聊天记录" center :visible.sync="dialogFormVisible2" width="800px" top="1vh">
      <chatRecord :states='1'></chatRecord>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible2 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="创建用户作为出险人" center :visible.sync="dialogFormVisible3" width="500px">
      <div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input v-model="reportcase.victimName" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
        <div style="margin-top: 10px;">
          手机号：<el-input v-model="nationalMobile" placeholder="请输入手机号" style='width: 300px;'></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="newDJXid()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="案件进度" center :visible.sync="dialogFormVisible4" width="800px" top="1vh">
      <jianbao v-if='this.$route.params.caseList' :caseId1='this.$route.params.caseList.obj.id'></jianbao>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible4 = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="创建关联案件" :visible.sync="centerDialogVisible" center top="1vh" width="1000px">
      <el-input placeholder="请输入案件编号" v-model="creatAboutText"></el-input>
      <el-button type="primary" @click='creatAboutFun'>搜索</el-button>
      <el-table empty-text="暂无数据" :data="nowCaseArr" class="mgt15" border>
        <el-table-column type="index" label="序号" min-width="30"></el-table-column>
        <el-table-column property="obj.obj.caseNo" label="案件编号" min-width="50"></el-table-column>
        <el-table-column label="用户姓名" min-width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.obj.victimList.length != 0">{{scope.row.obj.victimList[0].obj.victimName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="obj.obj.reporterContact" label="用户手机号" min-width="60"></el-table-column>
        <el-table-column label="证件信息" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.obj.victimList.length != 0">{{scope.row.obj.victimList[0].obj.idNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="30">
          <template slot-scope="scope">
            <span v-if="scope.row.obj.victimList.length != 0">
              {{scope.row.obj.victimList[0].obj.gender == 1 ? '男':'女'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="出险时间" min-width="80">
          <template slot-scope="scope">
            <span>{{setTime(scope.row.obj.obj.updateAt)}}</span>
          </template>
        </el-table-column>
        <el-table-column property="obj.obj.caseSrc" label="案件类型" min-width="80">
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="{ row, column, $index }">
            <el-button type="text" size="small" @click='handleAppCase1(row)'>选择此案件</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { detailOrdinaryCase } from "@/views/axios/api.js";
import strutils from "@/util/strutils.js";
import constants from "@/util/constants.js";
import { handleTokenInvalidResponse } from "@/util/auth";
import axios from "axios";
import {
  creatCase,
  updataOrdinaryCase,
  addSubUser,
  listSubUser,
  searchBasic,
  creatBasic,
  listDomestic,
  getPolicies,
  getCounties,
  getallGoingCase,
  getAllCoordinatedCases,
  userlist_regulator,
  casecreateEditTempCase,
  regulatorlistservice,
  listWorkTicket,
} from "@/views/axios/api.js";
import changeLanguage from "@/components/common/changeLange.vue";
import gpsBox from "@/views/map/searchMap.vue";
import chatRecord from "@/views/cmd_center/chatRecord";
import jianbao from "@/components/par/jianbao";
import countries from "./../js/countries.json";
import ruserId from "./ruserId";
export default {
  data() {
    return {
      contractEndTime:false,
      Longitudeandlatitude: "",
      Servicetypedefault: false,
      companies1: [],
      cpname: "",
      fcdBtn: true,
      ifyjjy: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      formRoute: "",
      llrName: JSON.parse(window.localStorage.getItem("insti")),
      tableData: "",
      cooperaterData: [], //联络人表格
      cooperaterDataList: [],
      cooperaterDataList1: [],
      cooperaterCaseArr: [],
      gongzuorenyuanimageUrl: "", //跟地工作人员图片
      jiashuimageUrl: "", //患者家属
      yiliaoimageUrl: "", //医疗图片
      cailiaoimageUrl: "", //线管材料图片
      imageUrl: "", //上传图片
      addContacterDialogVisible: false, //添加新联络人
      showcooperaterDialogVisible: false, //添加
      addcontacterform: {
        name: "",
        mobileNo: "",
        nationalId: "",
        passport: "",
        password: "",
      },
      formLabelWidth: "120px",
      xingshiServiceDialogVisible: false,
      creatAboutText: "",
      initialCaseId: "",
      initialCaseIdBtn: false,
      gpsBtn: false,
      gpsBox: false,
      centerBtn: false,
      typeId: this.$route.query.typeId,
      apptodo: 0,
      apptodolst: [],
      token: JSON.parse(window.localStorage.getItem("data")).data,
      value: "",
      centerDialogVisible: false,
      gridData: [
        {
          xu: "1",
          code: "AJ0001",
          address: "美国纽约第五大厦",
          name: "网易黄博士",
          phone: "+86 134764787",
          info: "身份证 5454514251414",
          sex: "男",
          date: "2018年6月5日 18:00",
        },
      ],
      domesticId: "", //国内协调人列表 GET请求参数
      reportcase: {
        insuranceSeat: "",
        miniPolicy: "",
        caseProductName: "",
        subRegulatorId: "",
        remark: "",
        token: "",
        reportUser: "",
        reportTs: new Date(),
        reporterContact: "",
        incidentTs: "",
        caseSrc: "",
        // caseNo: "4256544",
        caseInsured: 2,
        // addr: "境内",
        nation: "+86",
        city: "",
        siteabroadExpr: "境内",
        addr: "",
        weatherIncident: 2,
        weatherTag: "",
        accidentType: "",
        victimName: "",
        insurancePolicyNo: "",
        idNo: "",
        insuranceCompanyId: "",
        injuredPart: "",
        incidentDesc: "",
        regulatorId: 1,
        incidentType: 800,
        djxId: "",
        // victimId: '',
        latitude: "",
        longitude: "",
        caseSrcDesc: "", //案件来源中英文
        gender: "",
        initialCaseId: "", //关联的案件ID
        //汇合地点
        addr1: "境内",
        rendezvous: "",
        rlng: "",
        rlat: "1",
        rCountryCode: "+86",
        rCity: "",
        //end
        channel: "",
        channel1: "",
        travelId: "",
        subServiceType: "", //星使类型
        xsStart: "",
        xsEnd: "",
        xsDuration: "0",
        tUploadCnts: [],
        hospital: "",
        attendingDoctor: "",
        adContact: "",
        xsId: "",
        rContact: "",
        objType: "",
        memberLevelId: null,
      },
      travelAgency: "", //旅行社选择
      policy: null,
      companies: [
        {
          insti: {
            name: "江泰救援",
            id: "1",
          },
          inContract: 1,
        },
      ],
      objTypeList: [
        {
          label: "平安总部",
          key: 0,
        },
        {
          label: "平安宁夏",
          key: 1,
        },
      ],
      casesrclst: [
        "一键救命",
        "电话求救",
        "保险公司转接",
        "其他",
        "保单卡报案",
        "安全中心报案",
      ],
      subServiceTypeSel: [
        "陪同就医",
        "住院案件",
        "死亡案件",
        "案件信息核实案例",
      ],
      chanelSelect: ["旅责险", "华助AA", "大救星救援卡", "其他"],
      abroad: ["境内", "境外"],
      genderlst: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      countries: [],
      counties: [],
      counties1: [],
      disasters: ["气象灾害", "海洋灾害", "洪水灾害", "地质灾害", "其他"],
      // accidentTypes:[],
      accidentTypes: [
        {
          serviceType: "疏通马桶服务",
          amount: 0,
        },
        {
          serviceType: "开锁服务",
          amount: 0,
        },
        {
          serviceType: "油烟机清洗",
          amount: 0,
        },
        {
          serviceType: "油烟机拆洗",
          amount: 0,
        },
        {
          serviceType: "保洁2小时",
          amount: 0,
        },
        {
          serviceType: "保洁4小时",
          amount: 0,
        },
        {
          serviceType: "擦玻璃小户型（100平米下）",
          amount: 0,
        },
        {
          serviceType: "擦玻璃大户型（100-150平米）",
          amount: 0,
        },
        {
          serviceType: "马桶/坐便疏通",
          amount: 0,
        },
        {
          serviceType: "居家开锁",
          amount: 0,
        },
        {
          serviceType: "抽油烟机清洗",
          amount: 0,
        },
        {
          serviceType: "冰箱清洗",
          amount: 0,
        },
        {
          serviceType: "空调清洗",
          amount: 0,
        },
        {
          serviceType: "洗衣机清洗",
          amount: 0,
        },{
            serviceType: "清洁口腔",
            amount: 0
          },{
            serviceType: "衣物干洗",
            amount: 0
          },{
            serviceType: "全屋打扫",
            amount: 0
          }
      ],
      // accidentTypes: ["马桶疏通", "开锁服务","油烟机清洗","油烟机拆洗","保洁2小时","保洁4小时","擦玻璃小户型（100平米下）","擦玻璃大户型（100-150平米）"],
      tcm: [
        null,
        {
          name: "江泰救援",
          id: "1",
        },
      ],
      callCase: {
        contactName: "", //对接人
        contactNo: "", //联系方式
        company: "", //公司名称
        description: "",
        caseType: 0, //0 普通 1 咨询
        confirmed: 1, //0 待确认  1 已确认
      },
      fileObj: "",
      restaurants: "",
      nationalMobile: "",
      verifyId2: "",
      imageArr: [],
      alertyb: true,
      nowCaseArr: [],
      nowCaseArr1: [],
      ruserId: "",
      /** 工单列表（list-work-ticket） */
      workTicketList: [],
      /** obj 有值时展示「问题履约保单」 */
      showProblemPolicyTip: false,
    };
  },
  mounted: function () {
    this.countries = countries;
    this.loadcompanies();
    this.loadAppCases();
    if (this.$route.params.caseList) {
      this.handleAppCase(true, 0, true);
      this.getListWorkTicket();
    } else {
      this.loadcounties();
    }
    if (this.$route.name == "callCase1" || this.$route.name == "newstar1") {
      this.centerBtn = true;
    }
    this.getCooperaterList();
    this.getBriefList();
    this.restaurants = this.loadAll();
    this.getnowCase();
    this.getdata();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.formRoute = from.name;
    });
  },
  components: {
    changeLanguage,
    gpsBox,
    chatRecord,
    jianbao,
    ruserId,
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
    /**
     * 根据 memberLevelId 返回会员等级展示文案
     * @returns {string}
     */
    memberLevelLabel() {
      var levelId = Number(this.reportcase.memberLevelId);
      var levelMap = {
        [-1]: "普通会员",
        1: "黄铜会员",
        2: "白银会员",
        3: "黄金会员",
        4: "铂金会员",
        5: "钻石会员",
        1000: "至尊会员",
      };
      return levelMap[levelId] !== undefined ? levelMap[levelId] : "";
    },
    /**
     * 会员等级对应的样式类名
     * @returns {string}
     */
    memberLevelClass() {
      var levelId = Number(this.reportcase.memberLevelId);
      var classMap = {
        [-1]: "normal",
        1: "bronze",
        2: "silver",
        3: "gold",
        4: "platinum",
        5: "diamond",
        1000: "supreme",
      };
      return classMap[levelId] !== undefined ? classMap[levelId] : "";
    },
  },
  methods: {
    /**
     * 按保单号查询工单列表（creatCase 进入家财页后调用）
     */
    getListWorkTicket() {
      var ticketNo = this.reportcase.insurancePolicyNo || "";
      // creatCase 页保单号可能落在 victim.idNo / helpOrder.extra.policyNo
      if (!ticketNo && this.$route.params.caseList) {
        var caseList = this.$route.params.caseList;
        var vict =
          caseList.victimList && caseList.victimList[0]
            ? caseList.victimList[0].obj
            : null;
        if (vict && vict.insurancePolicyNo) {
          ticketNo = vict.insurancePolicyNo;
        } else if (
          caseList.helpOrder &&
          caseList.helpOrder.extra
        ) {
          try {
            ticketNo = JSON.parse(caseList.helpOrder.extra).policyNo || "";
          } catch (e) {
            ticketNo = "";
          }
        }
        if (!ticketNo && vict && vict.idNo) {
          ticketNo = vict.idNo;
        }
      }
      if (!ticketNo) {
        console.log("list-work-ticket 跳过：保单号为空");
        return;
      }
      var data = {
        token: this.token,
        ticketNo: ticketNo,
        start: 0,
        count: 100,
      };
      listWorkTicket(data)
        .then((res) => {
          console.log("list-work-ticket", res);
          if (res.data && res.data.code == 0) {
            this.workTicketList = res.data.obj || [];
            this.showProblemPolicyTip =
              Array.isArray(this.workTicketList) && this.workTicketList.length > 0;
          } else {
            this.workTicketList = [];
            this.showProblemPolicyTip = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.showProblemPolicyTip = false;
        });
    },
    keydown(e){
		if(e.keyCode == 32){
			e.returnValue = false
		}
  },

    suoshuFunz() {
      if(this.reportcase.subRegulatorId != '' && this.reportcase.subRegulatorId != null && this.reportcase.subRegulatorId != undefined) {
        regulatorlistservice({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.reportcase.regulatorId,
        subRegulatorId: this.reportcase.subRegulatorId,
      }).then((res) => {
        if (res.data.obj.length != 0) {
          if (this.$route.query.caseId) {
            this.reportcase.accidentType = "";
          }
          this.accidentTypes = res.data.obj;
        }
        console.log(res);
      });
      }
    },
    // objTypechange() {
    //   console.log(this.reportcase.objType)
    // },
    insurancePolicyNoblur() {
      console.log(this.reportcase.insuranceCompanyId)
      if (
        this.reportcase.insuranceCompanyId != "" &&
        this.reportcase.insuranceCompanyId != null &&
        this.reportcase.insuranceCompanyId != undefined
      ) {
        userlist_regulator({
          token: JSON.parse(window.localStorage.getItem("data")).data,
          regulatorId: this.reportcase.insuranceCompanyId,
        }).then((res) => {
          if(res.data.obj.length > 0) {
            this.reportcase.subRegulatorId = res.data.obj[0].id;
          }
          for (var i = 0; i < res.data.obj.length; i++) {
            if (res.data.obj[i].recognitionCode != null &&  res.data.obj[i].recognitionCode != '') {
              for (
                var k = 0;
                k < res.data.obj[i].recognitionCode.split(",").length;
                k++
              ) {
                for (
                  var j = 0;
                  j < res.data.obj[i].recognitionCode.split(",").length;
                  j++
                ) {
                  if (
                    res.data.obj[i].recognitionCode.split(",")[j] ==
                    this.reportcase.insurancePolicyNo.substring(
                      0,
                      res.data.obj[i].recognitionCode.split(",")[k].length
                    )
                  ) {
                    this.reportcase.subRegulatorId = res.data.obj[i].id;
             
                  }
                }
              }
            }
          }
         
          console.log(this.reportcase.subRegulatorId);
        });
      }
      // alert(this.reportcase.insuranceCompanyId)
      if(this.reportcase.insuranceCompanyId == 8) {
        if(this.typeId == 800) {
        if(this.reportcase.insurancePolicyNo.length > 20) {
        this.$message.error("保单位数超出20位，是否确认继续");
        // return;
      }
      if(this.reportcase.miniPolicy.length != 0) {
        if(this.reportcase.miniPolicy.length > 20) {
        this.$message.error("小保单位数超出20位，是否确认继续");
        // return;
      }
      }
      }
      }
    },
    Longitudeandlatitudeblur() {
      if (this.Longitudeandlatitude) {
        var m = this.Longitudeandlatitude.split(",");
        console.log(m);
        this.reportcase.latitude = m[1];
        this.reportcase.longitude = m[0];
      }
      console.log(this.Longitudeandlatitude);
    },
    draft() {
      this.$router.push({
        name: "draft",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.typeId,
        },
      });
    },
    idnochange() {
      if (this.reportcase.idNo.length == 18) {
        var str2 = this.reportcase.idNo;
        var num = str2.charAt(16);
        //console.log(num);
        if (num % 2 == 0) {
          console.log("女");
          this.reportcase.gender = 2;
        } else {
          this.reportcase.gender = 1;
          console.log("男");
        }
      }
    },
    accidentTypechange() {
      if (this.reportcase.accidentType == "疏通马桶服务") {
      } else {
      }
    },
    contractEndTimechange(item) {
      if(item.contractEndTime !=null && item.contractEndTime != '') {
          if(item.contractEndTime < new Date().getTime()) {
            this.contractEndTime = true
          }else {
            this.contractEndTime = false
          }
      }else {
        this.contractEndTime = false
      }

    },
    getdata() {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.reportcase.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
    },
    addSubUserFun() {
      this.showcooperaterDialogVisible = true;
      setTimeout(() => {
        this.toggleSelection(this.cooperaterDataList);
      }, 500);
    },
    listDomestic(id) {
      //协调人
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        caseId: id,
      };
      listDomestic(data)
        .then((res) => {
          this.cooperaterDataList = res.data.obj;
          var cooperaterDataList = [];
          this.cooperaterDataList.forEach((item) => {
            this.cooperaterData.forEach((item1) => {
              if (item1.id == item.id) {
                cooperaterDataList.push(item1);
              }
            });
          });
          this.cooperaterDataList = cooperaterDataList;
          // this.toggleSelection(cooperaterDataList)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadAll() {
      var that = this;
      fetch(constants.domain + "rescue/xingshi/search_agent", {
        method: "POST",
        body: `token=${this.token}&name=`,
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          // console.log(data.obj,'所有旅行社')
          that.restaurants = data.obj;
        });
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (travelName) => {
        // console.log(travelName,'单车')
        return (
          travelName.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    setTime(str) {
      return constants.time(str);
    },
    setTxt(str, status) {
      var data = constants.setTxt(str, status);
      if (data) {
        return data;
      } else {
        return str;
      }
    },
    back() {
      this.$router.go(-1);
    },
    //获取国内协调人列表
    getCooperaterList() {
      var data = {
        token: this.token,
        count: 100,
        start: 0,
        all: 1,
      };
      listSubUser(data)
        .then((res) => {
          this.cooperaterData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addSubUser() {
      var that = this;
      var data = {};
      if (this.addcontacterform.name == "") {
        this.$message.error("姓名不能为空");
      } else if (this.addcontacterform.mobileNo == "") {
        this.$message.error("手机号不能为空");
      } else if (this.addcontacterform.nationalId == "") {
        this.$message.error("证件号码不能为空");
      } else if (this.addcontacterform.passport == "") {
        this.$message.error("登录名不能为空");
      } else if (this.addcontacterform.password == "") {
        this.$message.error("密码不能为空");
      } else {
        // data = this.addcontacterform;
        data = Object.assign(this.addcontacterform, {
          token: this.token,
        });
        addSubUser(data)
          .then((res) => {
            if (res.data.code == 0) {
              this.addContacterDialogVisible = false;
              that.getCooperaterList();
              this.$refs.ruleForm.resetFields();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //上传图片
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      // console.log(this.imageUrl)
    },
    requestFile(param) {
      // this.uploadBtn=true;
      var fileObj = param.file;
      console.log(param, "图片擦书");
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      var form = new FormData(); // FormData 对象
      var token = JSON.parse(window.localStorage.getItem("data")).data;
      form.append("file", fileObj); // 文件对象
      form.append("token", token); // 文件对象
      // form.append('caseId', '')
      axios
        .post(constants.domain + "rescue/case/upload_file", form, config)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            // this.fileUrl.push(res.data.obj);
            // this.uploadBtn=false;
            if (param.action == "gongzuorenyuanimageUrl") {
              this.gongzuorenyuanimageUrl = res.data.obj;
              var gongzuorenyuanObj = {
                description: "跟地接社工作人员照片",
                objType: "15",
                url: res.data.obj,
              };
              this.imageArr.push(gongzuorenyuanObj);
            } else if (param.action == "jiashuimageUrl") {
              this.jiashuimageUrl = res.data.obj;
              var jiashuObj = {
                description: "患者家属照片",
                objType: "16",
                url: res.data.obj,
              };
              this.imageArr.push(jiashuObj);
            } else if (param.action == "yiliaoimageUrl") {
              this.yiliaoimageUrl = res.data.obj;
              var yiliaoObj = {
                description: "所在医疗机构及科室的照片",
                objType: "17",
                url: res.data.obj,
              };
              this.imageArr.push(yiliaoObj);
            } else if (param.action == "cailiaoimageUrl") {
              this.cailiaoimageUrl = res.data.obj;
              var cailiaoObj = {
                description: "医疗证明及其他相关材料照片",
                objType: "18",
                url: res.data.obj,
              };
              this.imageArr.push(cailiaoObj);
            }
          }
          // console.log(JSON.stringify(this.imageArr))
          this.reportcase.tUploadCnts = JSON.stringify(this.imageArr);
          console.log(this.reportcase.tUploadCnts);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
      return true;
    },
    //获取简报
    getBriefList() {
      fetch(constants.domain + "rescue/xingshi/list_brief", {
        method: "POST",
        body: `token=${this.token}&caseId=&count=10&start=1`,
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {});
    },
    changeAppcase(idx) {
      // this.reportcase.latitude = '';
      // this.reportcase.longitude = '';
      this.reportcase.rlat = "";
      this.reportcase.rlng = "";
      this.handleAppCase(true, idx);
    },
    suoshuFun() {
      console.log(this.reportcase.insuranceCompanyId);
      console.log(this.reportcase.insurancePolicyNo);
      if (
        this.reportcase.insurancePolicyNo != "" &&
        this.reportcase.insurancePolicyNo != null &&
        this.reportcase.insurancePolicyNo != undefined
      ) {
        userlist_regulator({
          token: JSON.parse(window.localStorage.getItem("data")).data,
          regulatorId: this.reportcase.insuranceCompanyId,
        }).then((res) => {
          for (var i = 0; i < res.data.obj.length; i++) {
            if (res.data.obj[i].recognitionCode != null &&  res.data.obj[i].recognitionCode != '') {
              for ( var k = 0; k < res.data.obj[i].recognitionCode.split(",").length; k++) {
                for ( var j = 0; j < res.data.obj[i].recognitionCode.split(",").length; j++) {
                  console.log(res.data.obj[i].recognitionCode.split(",")[j])
                  console.log(this.reportcase.insurancePolicyNo.substring(0,res.data.obj[i].recognitionCode.split(",")[k].length))
                  if (res.data.obj[i].recognitionCode.split(",")[j] == this.reportcase.insurancePolicyNo.substring(0,res.data.obj[i].recognitionCode.split(",")[k].length)) {
                    this.reportcase.subRegulatorId = res.data.obj[i].id; 
                  }
                }
              }
            }
          }
          console.log(this.reportcase.subRegulatorId);
        });
      }
      this.reportcase.regulatorId = this.reportcase.insuranceCompanyId;
      this.reportcase.subRegulatorId = "";
      this.insurancePolicyNoblur();
      this.getdata();
    },
    genderselect() {
      if (this.reportcase.gender == "女" || this.reportcase.gender == 2) {
        this.reportcase.gender = 2;
      } else {
        this.reportcase.gender = 1;
      }
      // console.log(this.reportcase.gender + "-" + this.reportcase.gender);
    },
    //查询出险人手机号
    queryPhone() {
      var data = {
        token: this.token,
        nationalMobile: this.nationalMobile,
      };
      searchBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.obj == null) {
            this.$message("没有查询到您的信息，请先去创建");
          } else {
            this.reportcase.victimName =
              res.data.obj.realName || res.data.obj.name;
            this.reportcase.djxId = res.data.obj.id;
            if (res.data.obj2.verifyId) {
              this.verifyId2 = res.data.obj2.verifyId;
            } else {
              this.verifyId2 = res.data.obj2.verifyId2;
            }
            this.reportcase.idNo = this.verifyId2;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询保单
    B_queryBaodanClick() {
      if (this.reportcase.idNo == "")
        return this.$message.error("请输入出险人证件");
      var data = {
        token: this.token,
        hit: this.verifyId2,
      };
      getPolicies(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0 && res.data.obj.length != 0) {
            this.reportcase.insurancePolicyNo = res.data.obj[0].docNo;
            this.reportcase.insuranceCompanyId = res.data.obj[0].regulatorId;
            this.reportcase.caseInsured = 1;
          } else {
            this.$message.error("未查询到，保单号码");
            this.reportcase.caseInsured = 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //创建大救星账户
    newDJXid() {
      if (this.reportcase.victimName == "") {
        return this.$message.error("创建账户时出险人姓名不能为空");
      } else if (this.nationalMobile == "") {
        return this.$message.error("创建账户时手机号不能为空");
      }
      var data = {
        token: this.token,
        name: this.reportcase.victimName,
        nationalMobile: this.nationalMobile,
      };
      creatBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("创建成功");
            this.reportcase.djxId = res.data.obj.id;
            this.dialogFormVisible3 = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAppCase(checked, idx, params, data) {
      var z = this;
      var ow = null;
      if (params) {
        ow = this.$route.params.caseList;
        this.initialCaseIdBtn = true;
      } else {
        if (data) {
          ow = data.obj;
          this.initialCaseIdBtn = true;
        } else {
          ow = z.apptodolst[idx];
        }
      }
      if (checked) {
        for (var i = 0; i < z.apptodolst.length; ++i) {
          var o1 = z.apptodolst[i];
          if (i != idx) {
            o1.checked = false;
          } else {
            o1.checked = true;
          }
        }
        if (ow != null) {
          this.reportcase.otherTypeName = ow.obj.otherTypeName;
          var o = ow.obj;
          z.reportcase.memberLevelId = o.memberLevelId;

          z.reportcase.coupon_discount_id =
            ow.helpOrder && ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).coupon_discount_id
              : "";
          z.reportcase.idProfitRedeem =
            ow.helpOrder && ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).idProfitItem
              : "";
          z.reportcase.couponName =
            ow.helpOrder && ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).couponName
              : "";
          z.reportcase.xsId = ow.helpOrder ? ow.helpOrder.id : "";
          z.reportcase.incidentId = o.id;
          z.reportcase.initialCaseId = o.initialCaseId;
          z.reportcase.reportUser = o.reportUser;
          z.reportcase.remark = o.remark;
          z.reportcase.caseProductName = o.caseProductName;
          z.reportcase.subRegulatorId = o.subRegulatorId;
          if (o.reportTs != null) z.reportcase.reportTs = o.reportTs;
          z.reportcase.reporterContact = o.reporterContact;
          if (o.incidentTs != null) {
            z.reportcase.incidentTs = o.incidentTs;
          } else {
            z.reportcase.incidentTs = new Date();
          }
          z.reportcase.caseSrc = o.caseSrc;
          z.reportcase.caseNo = o.caseNo;
          z.reportcase.caseInsured = o.caseInsured;
          if (ow.generalLocation != null) {
            var loc = ow.generalLocation;
            console.log(loc);
            z.reportcase.siteabroadExpr = loc.nation == "+86" ? "境内" : "境外";
            z.reportcase.nation = loc.nation;

            z.reportcase.city = loc.city;
            z.reportcase.addr = loc.addr;
            z.reportcase.latitude = loc.latitude;
            z.reportcase.longitude = loc.longitude;
            z.loadcounties();
            console.log(z.reportcase.addr);
          } else {
            z.reportcase.siteabroadExpr = "";
            z.reportcase.nation = "";
            z.reportcase.city = "";
            z.reportcase.addr = "";
          }
          if (o.weatherIncident) {
            z.reportcase.weatherIncident = o.weatherIncident;
          }
          z.reportcase.weatherTag = o.weatherTag;
          if (o.accidentType) {
            z.reportcase.accidentType = o.accidentType;
          }
          console.log(ow);
          if (ow.helpOrder != null) {
            if (
              JSON.parse(ow.helpOrder.extra).serviceType != "" &&
              JSON.parse(ow.helpOrder.extra).serviceType != null &&
              JSON.parse(ow.helpOrder.extra).serviceType != undefined
            ) {
              if (JSON.parse(ow.helpOrder.extra).serviceType == 100) {
                z.reportcase.accidentType = "疏通马桶服务";
              } else if (JSON.parse(ow.helpOrder.extra).serviceType == 200) {
                z.reportcase.accidentType = "开锁服务";
              }
            }
          }
          // if(this.typeId == 800) {
          //   z.reportcase.accidentType = ''
          // }
          if (ow.victimList != null && ow.victimList.length > 0) {
            var vict = ow.victimList[0].obj;
            z.reportcase.victimName = vict.victimName;
            z.reportcase.gender = vict.gender;
            z.reportcase.insurancePolicyNo = vict.insurancePolicyNo
              ? vict.insurancePolicyNo
              : ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).policyNo
              : "";
            z.reportcase.idNo = vict.idNo;
            if (vict.insuranceCompanyId != null) {
              z.reportcase.insuranceCompanyId = vict.insuranceCompanyId;
            } else {
              z.reportcase.insuranceCompanyId = 1;
            }
            this.reportcase.djxId = ow.victimList[0].obj.djxId;
            this.reportcase.contact = ow.victimList[0].obj.contact;
            this.reportcase.insurancePaper =
              ow.victimList[0].obj.insurancePaper;
            this.reportcase.victimId = ow.victimList[0].obj.id;
            z.reportcase.injuredPart = ow.victimList[0].obj.injuredPart;
          } else {
            z.reportcase.victimName = "";
            z.reportcase.gender = "";
            z.reportcase.insurancePolicyNo =
              ow.helpOrder && ow.helpOrder.extra
                ? JSON.parse(ow.helpOrder.extra).policyNo
                : "";
            z.reportcase.idNo = "";
            z.reportcase.insuranceCompanyId = 1;
          }
          z.reportcase.regulatorId = z.reportcase.insuranceCompanyId;
          // if(JSON.parse(this.$route.params.caseList.helpOrder.extra) != '' && JSON.parse(this.$route.params.caseList.helpOrder.extra) != null && JSON.parse(this.$route.params.caseList.helpOrder.extra) != undefined) {
          //     this.reportcase.idProfitRedeem = JSON.parse(this.$route.params.caseList.helpOrder.extra).idProfitItem
          // }
          z.reportcase.incidentDesc = o.incidentDesc;
          z.reportcase.caseSrcDesc = o.caseSrcDesc;
          if (this.$route.name == "callCase1" && ow.insuranceContact) {
            z.reportcase.incidentDesc = ow.obj.incidentDesc;
            this.callCase.contactName = ow.insuranceContact.contactName;
            this.callCase.company = ow.insuranceContact.company;
            this.callCase.contactNo = ow.insuranceContact.contactNo;
            this.callCase.description = ow.insuranceContact.description;
          }
        }
      }
    },
    //删除案件中的国内联络人
    handleClick(index) {
      this.cooperaterDataList.splice(index, 1);
    },
    //导入案件
    loadcounties(data1, status, id) {
      var country = "";
      if (id == 1) {
        country = this.reportcase.nation;
      } else {
        country = this.reportcase.rCountryCode;
      }
      var data = {
        token: this.token,
        country,
      };
      console.log(data);
      getCounties(data)
        .then((res) => {
          var Btn = false;
          if (!status) {
            this.counties = uniq(res.data.obj);
            this.counties1 = uniq(res.data.obj);
            return;
          }
          if (id == 1) {
            this.counties = uniq(res.data.obj);
            if (data1.country == "中国") {
              this.reportcase.siteabroadExpr = "境内";
            } else {
              this.reportcase.siteabroadExpr = "境外";
            }
            console.log(data1.cityCode);
            if (data1.cityCode) {
              this.reportcase.city = data1.cityCode;
              this.counties.forEach((item) => {
                if (item.cityCode == data1.cityCode) {
                  Btn = true;
                }
              });
              if (!Btn) {
                console.log(item.cityCode + "," + data1.cityCode);
                this.$message.error("未自动选择城市，请手动选择");
                this.reportcase.city = "";
              }
            } else {
              console.log(item.cityCode + "," + data1.cityCode);
              this.$message.error("未自动选择城市，请手动选择");
              this.reportcase.city = "";
            }
          } else {
            this.counties1 = uniq(res.data.obj);
            if (data1.country == "中国") {
              this.reportcase.addr1 = "境内";
            } else {
              this.reportcase.addr1 = "境外";
            }
            if (data1.cityCode) {
              this.reportcase.rCity = data1.cityCode;
              this.counties1.forEach((item) => {
                if (item.cityCode == data1.cityCode) {
                  Btn = true;
                }
              });
              if (!Btn) {
                console.log(item.cityCode + "," + data1.cityCode);
                this.$message.error("未自动选择城市，请手动选择");
                this.reportcase.rCity = "";
              }
            } else {
              console.log(item.cityCode + "," + data1.cityCode);
              this.$message.error("未自动选择城市，请手动选择");
              this.reportcase.rCity = "";
            }
          }
        })
        .catch((err) => {
          console.log(res);
        });
    },
    loadcompanies() {
      var z = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/user/list_regulator";
      cmd.data = new Object();
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        z.companies = r;
        var ntcm = new Object();
        for (var i = 0; i < r.length; ++i) {
          var nt = r[i];
          ntcm[nt.insti.id] = nt;
        }
        z.tcm = ntcm;
      };
      s2c(cmd);
    },
    showinsurance() {
      if (this.policy != null) {
        window.open(this.policy.detailUrl);
      }
    },

    caseabroad(id) {
      if (id == 1) {
        if (this.reportcase.siteabroadExpr == "境内") {
          this.reportcase.nation = "+86";
        } else {
          this.reportcase.nation = "";
        }
      } else {
        if (this.reportcase.addr1 == "境内") {
          this.reportcase.rCountryCode = "+86";
        } else {
          this.reportcase.rCountryCode = "";
        }
      }
      this.loadcounties();
    },
    loadAppCases() {
      var _this = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/case/list_case_collection";
      cmd.data = new Object();
      cmd.data.status = 90;
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        _this.apptodo = r.length;
        if (_this.apptodo && _this.apptodo > 0) {
          var rr = [];
          for (var i = 0; i < _this.apptodo; i++) {
            var o1 = r[i];
            o1.checked = false;
            _this.apptodolst.push(o1);
          }
          var index1 = "";
          if (_this.$route.query.caseId) {
            _this.apptodolst.forEach((item, index) => {
              if (item.victimList[0].obj.id == _this.$route.query.caseId) {
                index1 = index;
              }
            });
            _this.changeAppcase(index1);
          }
        } else if (_this.$route.query.caseId) {
          var data = {
            token: _this.token,
            caseId: _this.$route.query.caseId,
          };
          detailOrdinaryCase(data)
            .then((res) => {
              _this.handleAppCase(true, 0, false, res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      };
      s2c(cmd);
    },
    successTo() {
      this.$router.push({
        name: "ComAwait",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.typeId,
        },
      });
    },

    submitcase(type, status) {
      //insuranceCompanyId
      // this.$router.push({
      //               name: 'helpStart'
      //             })
      var z = this;
      if(this.contractEndTime) {
          this.$message.error("合同已结束");
          return;
      }
      if (type == 2) {
        var data = {};
        if (this.$route.query.creat) {
          //从创建关联案件过来的为创建案件
          this.initialCaseIdBtn = false;
        }
        if (this.initialCaseIdBtn) {
          //补充案件的时候不要关联ID
          delete this.reportcase.initialCaseId; //关联案件IDinitialCaseId
        } else {
          //创建
          this.reportcase.initialCaseId = this.initialCaseId;
          delete this.reportcase.id;
          // delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
          if (this.typeId != 800) {
            delete this.reportcase.incidentId;
            delete this.reportcase.xsId;
          }
        }
        if (this.$route.query.creat == 1) {
          this.reportcase.incidentId = this.$route.query.caseId;
        }
        // delete this.reportcase.incidentId;
        // if (stil.judgeNull(this.reportcase.subServiceType)) {
        //   this.$message.error("案件类型不能为空");
        //   return;
        // }
        if(this.reportcase.insuranceCompanyId == 8) {
          if(this.typeId == 800) {
          if(this.reportcase.insurancePolicyNo.length > 20) {
          this.$message.error("保单位数超出20位，是否确认继续");
          // return;
        }
        if(this.reportcase.miniPolicy.length != 0) {
          if(this.reportcase.miniPolicy.length > 20) {
          this.$message.error("小保单位数超出20位，是否确认继续");
          // return;
        }
        }
        }
        }

        if (stil.judgeNull(this.reportcase.reportTs)) {
          this.$message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          this.$message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          this.$message.error("报案电话不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.incidentTs)) {
          this.$message.error("出险时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.caseSrc)) {
          this.$message.error("案件来源不能为空");
          return;
        }
        // if (stil.judgeNull(this.reportcase.caseSrcDesc)) {
        //   this.$message.error("来源说明不能为空");
        //   return;
        // }
        // if (stil.judgeNull(this.reportcase.channel)) {
        //   this.$message.error("渠道不能为空");
        //   return;
        // }
        if (this.reportcase.channel == "旅责险") {
          if (stil.judgeNull(this.reportcase.travelId)) {
            this.$message.error("旅行社名称不能为空");
            return;
          }
        } else {
          if (
            this.reportcase.channel1 == "其他" ||
            this.reportcase.channel == "其他"
          ) {
            this.$message.error("旅行社名称不能为空");
            return;
          }
        }

        if (
          stil.judgeNull(this.reportcase.nation) ||
          stil.judgeNull(this.reportcase.city) ||
          stil.judgeNull(this.reportcase.addr)
        ) {
          this.$message.error("出险地不能为空");
          return;
        }
        if (this.reportcase.latitude == "" || this.reportcase.longitude == "") {
          this.$message.error("出险地经纬度不能为空");
          return;
        }
        // if (this.reportcase.rlng == '' || this.reportcase.rlat == '') {
        // 	this.$message.error("汇合地点经纬度不能为空");
        // 	return;
        // }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (this.reportcase.weatherIncident != 1) {
          this.reportcase.weatherTag = null;
        }
        if (!constants.setTxt(this.reportcase.addr)) {
          this.reportcase.addr = `<zh-CN>${this.reportcase.addr}</zh-CN><en-US></en-US>`;
        }
        if (!constants.setTxt(this.reportcase.incidentDesc)) {
          this.reportcase.incidentDesc = `<zh-CN>${this.reportcase.incidentDesc}</zh-CN><en-US></en-US>`;
        }
        // if (!this.reportcase.djxId) {
        //   this.$message.error('没有检测到星使id，请查询或创建大救星账号')
        //   return
        // }
        if (this.companies1.length != 0) {
          if (this.reportcase.subRegulatorId == "") {
            this.$message.error("保险公司子公司不能为空");
            return;
          }
        }
        //电话报案
        this.reportcase.token = this.token;
        this.reportcase.incidentTs = new Date(
          this.reportcase.incidentTs
        ).getTime();
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime();
        if (this.reportcase.xsStart) {
          this.reportcase.xsStart = new Date(this.reportcase.xsStart).getTime(); //起始时间
        }
        if (this.reportcase.xsEnd) {
          this.reportcase.xsEnd = new Date(this.reportcase.xsEnd).getTime();
        }
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1;
        }
        this.domesticId = "";
        this.cooperaterDataList.forEach((item, index) => {
          if (index < this.cooperaterDataList.length - 1) {
            this.domesticId += "domesticId=" + item.id + "&";
          } else {
            this.domesticId += "domesticId=" + item.id;
          }
        });
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1;
        } else {
          this.reportcase.caseInsured = 2;
        }
        if (this.reportcase.channel == "旅责险") {
          this.reportcase.caseInsured = 3;
        }

        if (this.reportcase.caseInsured == 1 && this.alertyb) {
          this.dialogFormVisible1 = true;
          return;
        }
        // if (!this.fcdBtn) return this.$message('不要重复点击')
        // this.fcdBtn = false
        if (this.ruserId != "") {
          this.domesticId = this.domesticId + "&" + this.ruserId;
        }
        if (this.reportcase.channel == "其他") {
          this.reportcase.channel = this.reportcase.channel1;
        }
        data = Object.assign(this.reportcase, this.callCase);
        if (!status) {
          creatCase(data, this.domesticId)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success("操作成功");
                if (this.$route.name == "newstar") {
                  this.$router.push({
                    name: "Homestart2",
                    query: { typeId: 800 },
                  });
                } else {
                  this.$router.push({
                    name: "Homestart2",
                    query: { typeId: 800 },
                  });
                }
              }
            })
            .catch((err) => {
              this.fcdBtn = true;
              console.log(err);
            });
        } else {
          updataOrdinaryCase(data, this.domesticId)
            .then((res) => {
              this.initialCaseId;
              if (res.data.code == 0) {
                this.$message.success("补充信息成功");
                this.$router.go(-1);
              } else {
                this.$message.error(res.data.msg);
                this.fcdBtn = true;
              }
            })
            .catch((err) => {
              this.fcdBtn = true;
              console.log(err);
            });
        }
      } else {
        var data = {};
        console.log(this.reportcase);
        if (this.$route.query.creat) {
          //从创建关联案件过来的为创建案件
          this.initialCaseIdBtn = false;
        }
        if (this.initialCaseIdBtn) {
          //补充案件的时候不要关联ID
          delete this.reportcase.initialCaseId; //关联案件IDinitialCaseId
        } else {
          //创建
          this.reportcase.initialCaseId = this.initialCaseId;
          // delete this.reportcase.incidentId;
          delete this.reportcase.id;
          // delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
          delete this.reportcase.xsId;
        }
        if(this.reportcase.insuranceCompanyId == 8) {
          if(this.typeId == 800) {
          if(this.reportcase.insurancePolicyNo.length >20) {
          this.$message.error("保单位数超出20位，是否确认继续");
          // return;
        }
        if(this.reportcase.miniPolicy.length != 0) {
          if(this.reportcase.miniPolicy.length > 20) {
          this.$message.error("小保单位数超出20位，是否确认继续");
          // return;
        }
        }
        }
        }

        if (stil.judgeNull(this.reportcase.reportTs)) {
          this.$message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          this.$message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          this.$message.error("报案电话不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }

        //电话报案
        this.reportcase.token = this.token;
        this.reportcase.incidentTs = new Date(
          this.reportcase.incidentTs
        ).getTime();
        console.log(new Date(this.reportcase.reportTs).getTime());
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime();
        if (this.reportcase.xsStart) {
          this.reportcase.xsStart = new Date(this.reportcase.xsStart).getTime(); //起始时间
        }
        if (this.reportcase.xsEnd) {
          this.reportcase.xsEnd = new Date(this.reportcase.xsEnd).getTime();
        }
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1;
        }
        this.domesticId = "";
        this.cooperaterDataList.forEach((item, index) => {
          if (index < this.cooperaterDataList.length - 1) {
            this.domesticId += "domesticId=" + item.id + "&";
          } else {
            this.domesticId += "domesticId=" + item.id;
          }
        });
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1;
        } else {
          this.reportcase.caseInsured = 2;
        }
        if (this.reportcase.channel == "旅责险") {
          this.reportcase.caseInsured = 3;
        }

        if (this.reportcase.caseInsured == 1 && this.alertyb) {
          this.dialogFormVisible1 = true;
          return;
        }

        this.fcdBtn = false;
        if (this.ruserId != "") {
          this.domesticId = this.domesticId + "&" + this.ruserId;
        }
        if (this.reportcase.channel == "其他") {
          this.reportcase.channel = this.reportcase.channel1;
        }
        data = Object.assign(this.reportcase, this.callCase);

        if (isNaN(data.incidentTs)) {
          data.incidentTs = "";
        }

        // return
        if (!status) {
          casecreateEditTempCase(data, this.domesticId)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$message.success("保存成功");
                this.reportcase.incidentId = res.data.obj;
                // if (this.$route.name == 'newstar') {
                this.$router.push({
                  name: "draftdetails",
                  query: { typeId: 800, caseId: res.data.obj },
                });
                // } else {
                //   this.$router.push({
                //     name: 'Homestart2',
                //     query:{typeId:800}
                //   })
                // }
              }
            })
            .catch((err) => {
              this.fcdBtn = true;
              console.log(err);
            });
        }
      }
    },
    getGps(id) {
      this.gpsBox = true;
      this.$refs.changeLanguage.setBtn();
      document.getElementsByTagName("body")[0].style.height = "100vh";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      if (id == 1) {
        this.$refs.gpsBox.parendZx(this.reportcase.addr, id);
      } else {
        this.$refs.gpsBox.parendZx(this.reportcase.rendezvous, id);
      }
    },
    getGpshid(data, data1, id) {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      if (data.lat == "") return;
      if (id == 1) {
        this.reportcase.latitude = data.lat;
        this.reportcase.longitude = data.lng;
        setTimeout(() => {
          // this.reportcase.addr = data.address;
          console.log(this.reportcase.addr);
        }, 1000);
        console.log(data1);
        if (data1 == undefined)
          return this.$message.error("地址未自动匹配，请手动添加！");
        if (data1.country == "中国") {
          this.reportcase.nation = "+86";
        } else {
          this.countries.forEach((item) => {
            if (item.label == data1.country) {
              this.reportcase.nation = item.value;
            }
          });
        }
      } else {
        this.reportcase.rlat = data.lat;
        this.reportcase.rlng = data.lng;
        setTimeout(() => {
          this.reportcase.rendezvous = data.address;
        }, 1000);
        if (data1 == undefined)
          return this.$message.error("地址未自动匹配，请手动添加！");
        if (data1.country == "中国") {
          this.reportcase.rCountryCode = "+86";
        } else {
          this.countries.forEach((item) => {
            if (item.label == data1.country) {
              this.reportcase.rCountryCode = item.value;
            }
          });
        }
      }
      this.loadcounties(data1, true, id);
    },
    getGpshid1() {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    },
    time: constants.time,
    judgeNull: function (val) {
      return stil.judgeNull(val);
    },
    handleSelectionChange(val) {
      this.cooperaterDataList1 = val;
    },
    toggleSelection(rows) {
      console.log(this.$refs);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getnowCase() {
      //当前案件管理
      var data = {
        token: this.token,
      };
      var getList = null;
      if (this.llrName.type == 4) {
        getList = getAllCoordinatedCases(data);
      } else {
        getList = getallGoingCase(data);
      }
      getList
        .then((res) => {
          this.nowCaseArr = res.data.obj;
          this.nowCaseArr1 = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    creatAboutFun() {
      if (this.creatAboutText == "")
        return (this.nowCaseArr = this.nowCaseArr1);
      this.nowCaseArr = this.nowCaseArr.filter((item) => {
        return item.obj.obj.caseNo == this.creatAboutText;
      });
    },
    handleAppCase1(obj) {
      this.handleAppCase(true, 0, false, obj.obj);
      this.initialCaseIdBtn = true;
      this.centerDialogVisible = false;
    },
    getRuserId(id) {
      this.ruserId = id;
      console.log(id);
    },
    /**
     * 一键提取上门信息
     * 复制案件号、服务地址、服务经过、联系人姓名+电话等信息
     */
    extractServiceInfo() {
      try {
        // 构建要复制的信息
        let info = '';
        
        // 1. 案件号
        if (this.reportcase.caseNo) {
          info += `1.案件号：${this.reportcase.caseNo}\n`;
        } else {
          info += `1.案件号：暂无\n`;
        }
        
        // 2. 服务地址
        let address = '';
        if (this.reportcase.siteabroadExpr === '境外' && this.reportcase.nation) {
          // 境外地址
          const country = this.countries.find(item => item.value === this.reportcase.nation);
          const city = this.counties.find(item => item.cityCode === this.reportcase.city);
          address = `${country ? country.label : ''} ${city ? city.cityName : ''} ${this.reportcase.addr || ''}`;
        } else {
          // 境内地址
          const city = this.countries.find(item => item.cityCode === this.reportcase.city);
          address = `${city ? city.cityName : ''} ${this.reportcase.addr || ''}`;
        }
        
        // 清理地址中的多语言标签
        if (address) {
          // 移除 <zh-CN> 和 </zh-CN> 标签，只保留内容
          address = address.replace(/<zh-CN>(.*?)<\/zh-CN>/g, '$1');
          // 移除 <en-US> 和 </en-US> 标签
          address = address.replace(/<en-US>.*?<\/en-US>/g, '');
          // 清理多余的空格
          address = address.replace(/\s+/g, ' ').trim();
        }
        
        info += `2.服务地址：${address || '暂无'}\n`;
        
        // 3. 服务经过
        let serviceDesc = '';
        if (this.reportcase.incidentDesc) {
          // 如果是多语言格式，提取中文内容
          if (this.reportcase.incidentDesc.includes('<zh-CN>')) {
            const match = this.reportcase.incidentDesc.match(/<zh-CN>(.*?)<\/zh-CN>/);
            serviceDesc = match ? match[1] : this.reportcase.incidentDesc;
          } else {
            serviceDesc = this.reportcase.incidentDesc;
          }
        }
        info += `3.服务经过：${serviceDesc || '暂无'}\n`;
        
        // 4. 联系人姓名+电话
        let contactInfo = '';
        if (this.reportcase.reportUser && this.reportcase.reporterContact) {
          contactInfo = `${this.reportcase.reportUser} ${this.reportcase.reporterContact}`;
        } else if (this.reportcase.reportUser) {
          contactInfo = this.reportcase.reportUser;
        } else if (this.reportcase.reporterContact) {
          contactInfo = this.reportcase.reporterContact;
        } else {
          contactInfo = '暂无';
        }
        info += `4.联系人姓名+电话：${contactInfo}\n`;
        
        // 5. 预期服务时间
        let expectedServiceTime = '';
        if (this.reportcase.incidentTs) {
          // 格式化时间显示
          const date = new Date(this.reportcase.incidentTs);
          expectedServiceTime = date.toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        } else {
          expectedServiceTime = '暂无';
        }
        info += `5.预期服务时间：${expectedServiceTime}`;
        
        // 复制到剪贴板
        if (navigator.clipboard && window.isSecureContext) {
          // 现代浏览器使用 Clipboard API
          navigator.clipboard.writeText(info).then(() => {
            this.$message.success('上门信息已复制到剪贴板');
          }).catch(() => {
            this.fallbackCopyTextToClipboard(info);
          });
        } else {
          // 降级方案
          this.fallbackCopyTextToClipboard(info);
        }
        
      } catch (error) {
        console.error('提取信息失败:', error);
        this.$message.error('提取信息失败，请重试');
      }
    },
    
    /**
     * 降级复制方案
     */
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('上门信息已复制到剪贴板');
        } else {
          this.$message.error('复制失败，请手动复制');
          console.log('复制的内容：', text);
        }
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
        console.log('复制的内容：', text);
      }
      
      document.body.removeChild(textArea);
    },
  },
};

var stil = strutils;

function forpst(obj) {
  if (stil.judgeNull(obj)) return "";
  var ks = Object.keys(obj);
  var postdata = "";
  for (var i = 0; i < ks.length; ++i) {
    var d = obj[ks[i]];
    if (d == null) continue;
    if (d.constructor == Array) {
      for (var j = 0; j < d.length; ++j) {
        postdata += ks[i] + "=" + encodeURIComponent(d[j]);
        if (j != d.length - 1) {
          postdata += "&";
        }
      }
    } else if (d.constructor == Date) {
      postdata += ks[i] + "=" + d.getTime();
    } else {
      postdata += ks[i] + "=" + encodeURIComponent(d);
    }
    if (i != ks.length - 1) {
      postdata += "&";
    }
  }
  return postdata;
}

function s2c(cmd) {
  fetch(cmd.url, {
    method: "POST",
    body: forpst(cmd.data),
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then(function (res) {
      //console.log(res);
      return res.json();
    })
    .then(function (data) {
      if (handleTokenInvalidResponse(data)) {
        return;
      }
      if (data.code != 0) {
        var handled = false;
        if (cmd.transerr != null) {
          handled = cmd.transerr(data.code);
        }
        if (!handled) {
          var errtxt = e2t(data.code);
          this.$message.error(errtxt);
        }
      } else {
        cmd.succ(data.obj);
      }
    });
}

function e2t(errcode) {
  errcode = "ERR_" + errcode;
  if ("ERR_100001" == errcode) return "参数异常，请重新提交";
  if ("ERR_101000" == errcode) return "登录过期，请重新登录";
  if ("ERR_102000" == errcode) return "用户类型错误";
  if ("ERR_102002" == errcode) return "找不到此机构";
  if ("ERR_102003" == errcode) return "合约已失效";
  if ("ERR_102004" == errcode) return "案件状态错误，无法更新";
  if ("ERR_102005" == errcode) return "案件更新失败";
  if ("ERR_102006" == errcode) return "找不到此机构";
  if ("ERR_102007" == errcode) return "机构保存错误";
  if ("ERR_102008" == errcode) return "找不到此机构合约";
  if ("ERR_102009" == errcode) return "找不到此机构收费方式";
  if ("ERR_102010" == errcode) return "合约保存错误";
  if ("ERR_102011" == errcode) return "找不到此用户";
  if ("ERR_102012" == errcode) return "此案件已创立";
  if ("ERR_101001" == errcode) return "找不到此案件";
  if ("ERR_101002" == errcode) return "找不到方案";
  if ("ERR_101003" == errcode) return "您没有操作权限，请联系管理员";
  if ("ERR_102000" == errcode) return "找不到当前操作状态";
  if ("ERR_101004" == errcode) return "找不到案件出险人";
  if ("ERR_101010" == errcode) return "找不到此方案对应的服务清单";
  if ("ERR_101005" == errcode) return "此案件未推送机构";
  if ("ERR_101006" == errcode) return "救援机构尚未提交方案";
  if ("ERR_101007" == errcode) return "此案已审核，不能修改";
  if ("ERR_101008" == errcode) return "请勿重新提交方案";
  if ("ERR_101009" == errcode) return "找不到此上传资源，无法修改";
  if ("ERR_100000" == errcode) return "未知错误";
  return errcode;
}

function uniq(array) {
  var temp = [];
  var index = [];
  var l = array.length;
  for (var i = 0; i < l; i++) {
    for (var j = i + 1; j < l; j++) {
      if (array[i].cityCode == array[j].cityCode) {
        i++;
        j = i;
      }
    }
    temp.push(array[i]);
    index.push(i);
  }
  return temp;
}
</script>

<style scoped>
@import url("./../style.css");

/* @import url("./js/elementUI/index.css"); */
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.uploadStyle {
  margin-top: 15px;
  margin-left: 10px;
}

.uploadStyle span {
  float: left;
  width: 110px;
  font-size: 14px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.serviceBrief ul li h4 {
  border-bottom: 1px solid #eee;
  width: 200px;
  line-height: 24px;
}

.serviceBrief ul li h4 small {
  margin-left: 35px;
}

.el-row {
  margin-bottom: 20px;

  /* &:last-child {
      margin-bottom: 0;
    } */
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #f5f5f5;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  margin-top: 10px;
  text-align: center;
  line-height: 36px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

input.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.margint10 {
  padding-top: 10px;
}

.marginl10 .contactAddStyle {
  cursor: pointer;
  margin-left: 30px;
  float: right;
  font-size: 13px;
  color: #484646;
  font-weight: 400;
}

.marginl10 .contactAddStyle::before {
  content: "+";
  color: #00abf9;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 7.5px;
  text-align: center;
  line-height: 15px;
  font-size: 16px;
  margin-right: 5px;
  border: 1px solid #00abf9;
}

.el-input,
.el-select {
  width: 50%;
}

.el-input__inner,
.el-input--suffix {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 50%;
}

.lisave {
  font-size: 10px;
  color: #399cff;
  cursor: pointer;
}

.w140 {
  width: 140px;
}

.w213 {
  width: 213px;
}

.w120 {
  width: 120px;
}

.f10 {
  font-size: 10px;
}

.w75 {
  width: 75px;
}

.w130 {
  width: 130px;
}

.w303 {
  width: 303px;
  display: inline-block;
}

.w88100 {
  width: 88%;
  display: inline-block;
}

.w200 {
  width: 200px;
}

.mgt5 {
  margin-top: 5px;
}

.mgt15 {
  margin-top: 15px;
}

.p1026 {
  padding: 10px 26px;
}

.h50 {
  height: 50px;
  line-height: 50px;
}

.span_node {
  font-weight: normal;
  font-size: 14px;
}

.w100 {
  width: 100px;
}

.app-aj div {
  padding: 0;
  margin: 10px 0;
}

.lianluo {
  overflow: hidden;
  font-size: 14px;
  margin-top: 20px;
  padding: 0 15px;
}

.lianluo li {
  float: left;
  width: 50%;
}

.lianluo li .must {
  color: red;
}

.marginCenter {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
  padding-top: 20px;
}

.blue {
  color: #00abf9;
  cursor: pointer;
}

.gpsBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: powderblue;
  overflow: hidden;
}

.back {
  background: url(./../images/back.png) left center no-repeat;
  padding-left: 20px;
  background-size: 15px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  left: 10px;
}

.member-level-header {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  font-weight: normal;
}

.member-level-badge {
  display: inline-block;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  border-radius: 12px;
  border: 1px solid transparent;
  vertical-align: middle;
}

.member-level-badge--normal {
  color: #606266;
  background: #f4f4f5;
  border-color: #dcdfe6;
}

.member-level-badge--bronze {
  color: #8b5a2b;
  background: linear-gradient(135deg, #fdf3e7 0%, #e8c9a0 100%);
  border-color: #cd7f32;
}

.member-level-badge--silver {
  color: #5a5a5a;
  background: linear-gradient(135deg, #fafafa 0%, #e0e0e0 100%);
  border-color: #b0b0b0;
}

.member-level-badge--gold {
  color: #8b6914;
  background: linear-gradient(135deg, #fff8e1 0%, #ffd54f 100%);
  border-color: #d4a017;
}

.member-level-badge--platinum {
  color: #4a5568;
  background: linear-gradient(135deg, #f7fafc 0%, #cbd5e0 100%);
  border-color: #a0aec0;
}

.member-level-badge--diamond {
  color: #1565c0;
  background: linear-gradient(135deg, #e3f2fd 0%, #90caf9 100%);
  border-color: #42a5f5;
}

.member-level-badge--supreme {
  color: #fff;
  background: linear-gradient(135deg, #7b1fa2 0%, #e91e63 100%);
  border-color: #9c27b0;
  box-shadow: 0 2px 6px rgba(156, 39, 176, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/Familywealth.vue